import Vue from "vue";
import VeeValidate from "vee-validate";
import messagesBR from "../../../../node_modules/vee-validate/dist/locale/pt_BR";

VeeValidate.Validator.localize({ pt_BR: messagesBR });
Vue.use(VeeValidate, {
  locale: "pt_BR",
});

Vue.mixin({
  $_veeValidate: {
    validator: "new",
  },
  methods: {
    async formHasErrors() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.$validator.pause();
      }
      return !valid;
    },
  },
});
